<script setup>

</script>

<template>
    <Panel>
        <template #header>
            <h4>Personal Details</h4>
        </template>
    </Panel>
</template>

<style scoped>

</style>